/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_preset_h1 = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} Timer`)
};

const es_timer_preset_h1 = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Temporizador de ${i?.label}`)
};

const de_timer_preset_h1 = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label}-Timer`)
};

const nl_timer_preset_h1 = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} Timer`)
};

const fr_timer_preset_h1 = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Minuteur ${i?.label}`)
};

const it_timer_preset_h1 = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Timer ${i?.label}`)
};

const pt_br2_timer_preset_h1 = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Temporizador de ${i?.label}`)
};

const pt_timer_preset_h1 = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Temporizador de ${i?.label}`)
};

const ja_timer_preset_h1 = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label}タイマー`)
};

const zh_timer_preset_h1 = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label}计时器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ label: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_preset_h1 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_preset_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_preset_h1", locale)
	if (locale === "en") return en_timer_preset_h1(inputs)
	if (locale === "es") return es_timer_preset_h1(inputs)
	if (locale === "de") return de_timer_preset_h1(inputs)
	if (locale === "nl") return nl_timer_preset_h1(inputs)
	if (locale === "fr") return fr_timer_preset_h1(inputs)
	if (locale === "it") return it_timer_preset_h1(inputs)
	if (locale === "pt-BR") return pt_br2_timer_preset_h1(inputs)
	if (locale === "pt") return pt_timer_preset_h1(inputs)
	if (locale === "ja") return ja_timer_preset_h1(inputs)
	return zh_timer_preset_h1(inputs)
};